import { useMediaQuery } from "usehooks-ts";

export type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";

export const breakpoints: Record<Breakpoint, number> = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const useUp = (breakpoint: Breakpoint) => {
  return useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`);
};

export const useDown = (breakpoint: Breakpoint) => {
  return useMediaQuery(`(max-width: ${breakpoints[breakpoint] - 1}px)`);
};
